import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssignmentIcon from '@mui/icons-material/Assignment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import SettingsIcon from '@mui/icons-material/Settings';
import InfoIcon from '@mui/icons-material/Info';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import ClientList from "../components/Module/Client/ClientList/ClientList";
import AccountsDetail from "../components/Module/Accounts/AccountsDetail";
import CardsList from "../components/Module/Cards/CardList/CardsList";
import CardSetting from "../components/Module/Cards/CardSetting/CardSetting";
import ReportTrn from "../components/Module/Reports/ReportTrn/ReportTrn";
import Setting from "../components/Module/Setting/Setting";
import {TPermission} from "./permissions";
import DriverCards from "../components/Module/DriverCards/DriverCards";
import HelperLinks from "../components/Module/Links/HelperLinks";
import MoneyTransfers from "../components/Module/MoneyTransfers";
import RegisterDriver from "../components/Module/RegisterDriver/RegisterDriver";
import MyCard from "../components/Module/MyCard/MyCard";
import Documents from "../components/Module/Documents/Documents";

export interface IMenu {
    icon?: JSX.Element;
    title?: string;
    hint?: string;
    /* Линк в случае отсутствия параметров */
    linkApp?: string;
    link?: string;
    linkRegExp? : RegExp;
    component?: JSX.Element;
    permission?: TPermission;
    notShowPermission?: TPermission;
}

export const menus: IMenu[] = [{
    icon: <PeopleAltIcon/>,
    title: '_lang.module.menu.0.title',
    hint: '_lang.module.menu.0.hint',
    linkApp: "clients",
    link: "clients",
    linkRegExp: /\/clients$/,
    component: <ClientList/>,
    permission: 'Holders'
}, {
    icon: <AssignmentIcon/>,
    title: '_lang.module.menu.1.title',
    hint: '_lang.module.menu.1.hint',
    linkApp: 'clients/0/accounts',
    link: "clients/:holderId/accounts",
    linkRegExp: /\/clients\/.*\/accounts.*/,
    component: <AccountsDetail/>,
    permission: 'Accounts'
}, {
    icon: <CreditCardIcon/>,
    title: '_lang.module.menu.2.title',
    hint: '_lang.module.menu.2.hint',
    linkApp: "holder/0/account/0/cards?from=client",
    link: "holder/:holderId/account/:accountId/cards",
    linkRegExp: /holder\/.*\/account\/.*\/cards.*/,
    component: <CardsList/>,
    permission: 'Cards'
}, {
    icon: <CreditCardIcon/>,
    title: '_lang.module.menu.2.title',
    hint: '_lang.module.menu.2.hint',
    linkApp: "driver/cards",
    link: "driver/cards",
    linkRegExp: /driver\/cards/,
    component: <DriverCards/>,
    permission: 'Driver'
}, {
    icon: <HistoryEduIcon/>,
    title: '_lang.module.menu.3.title',
    hint: '_lang.module.menu.3.hint',
    linkApp: "reports",
    link: "reports",
    linkRegExp: /reports/,
    component: <ReportTrn/>,
    permission: 'Reports'
}, {
    icon: <ReceiptLongIcon/>,
    title: '_lang.module.menu.8.title',
    hint: '_lang.module.menu.8.hint',
    linkApp: "documents",
    link: "documents",
    linkRegExp: /documents/,
    component: <Documents/>,
    permission: 'Config',
    notShowPermission: 'Driver'
}, {
    icon: <CurrencyExchangeIcon/>,
    title: '_lang.module.menu.6.title',
    hint: '_lang.module.menu.6.hint',
    linkApp: "exchange",
    link: "exchange",
    linkRegExp: /exchange/,
    component: <MoneyTransfers/>,
    permission: 'Transfers'
}, {
    icon: <CreditCardIcon/>,
    title: '_lang.module.menu.7.title',
    hint: '_lang.module.menu.7.hint',
    linkApp: "my-card",
    link: "my-card",
    linkRegExp: /my-card/,
    component: <MyCard/>,
    permission: 'All',
    notShowPermission: 'Driver'
}, {
    icon: <InfoIcon/>,
    title: '_lang.module.menu.4.title',
    hint: '_lang.module.menu.4.hint',
    linkApp: "info",
    link: "info",
    linkRegExp: /info/,
    component: <HelperLinks/>,
    permission: 'All'
}, {
    icon: <SettingsIcon/>,
    title: '_lang.module.menu.5.title',
    hint: '_lang.module.menu.5.hint',
    linkApp: "parameters",
    link: "parameters",
    linkRegExp: /parameters/,
    component: <Setting/>,
    permission: 'PersonalAccounts'
},

    {
        link: "holder/:holderId/account/:accountId/currentAccount/:currentAccount/card/:cardId/setting", component: <CardSetting/>, permission: 'Cards'
    }, {
        link: "otc=:otc&phone=:phone&cardId=:cardId", component: <RegisterDriver/>, permission: 'All'
    }];
